/**
 * @generated SignedSource<<3ea2b5db0aea5e17dbc37ac17cc068b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilterUser_filter",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapFilterUserField",
      "kind": "LinkedField",
      "name": "userFields",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MapFilterUserFieldSelect_userField"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MapFilterUser",
  "abstractKey": null
};
})();

node.hash = "62b879188637a6ec8e28cf664753a970";

module.exports = node;
